import React, { ReactElement } from "react";

interface RenderIfProps {
  condition: boolean;
  children: ReactElement;
}

export const RenderIf = ({
  condition,
  children,
}: RenderIfProps): ReactElement | null => {
  if (!condition) {
    return null;
  }

  return <>{children}</>;
};
